import {
  computed,
  onBeforeUnmount,
  ref,
  useStore
} from '@nuxtjs/composition-api'
import { from, filter, concatMap, tap, catchError, empty } from 'rxjs'

export default function useDetectVersion(context) {
  const store = useStore()

  const schedulingDetectVersionToReloadIntervalId = ref(null)

  const version = computed(() => store.state.version)
  const user = computed(() => store.state.authModule.user)

  onBeforeUnmount(() => {
    if (schedulingDetectVersionToReloadIntervalId.value) {
      clearInterval(schedulingDetectVersionToReloadIntervalId.value)
    }
  })

  function checkCookieIsEnabled() {
    // Quick test if browser has cookieEnabled host property
    if (navigator.cookieEnabled) return true
    // Create cookie
    document.cookie = 'cookietest=1'
    const ret = document.cookie.indexOf('cookietest=') !== -1
    // Delete cookie
    document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT'
    return ret
  }
  function detectVersionToReload() {
    // 1. detect cookie enable
    if (!checkCookieIsEnabled() && user?.value) {
      const err = new Error(`username: ${user.value.username} turn cookies off`)
      err.name = `TurnCookiesOffError`
      console.error(err)
      if (context.root.$sentry) {
        context.root.$sentry.captureException(err)
      }
      return
    }
    // 2. detect client-side version is different from server-side
    const currentVersion = version.value
    from(store.dispatch('getVersion'))
      .pipe(
        filter(version => currentVersion === version),
        // 3. is forceRefresh by backend/fingerprint
        concatMap(() => from(store.dispatch('isForceRefresh'))),
        filter(res => res),
        tap(() => {
          if ('serviceWorker' in navigator) {
            caches
              .keys()
              .then(cacheNames =>
                Promise.all(
                  cacheNames.map(cacheName => caches.delete(cacheName))
                )
              )
              .then(() => location.reload())
          } else {
            location.reload()
          }
        }),
        catchError(err => {
          console.error(err)
          return empty()
        })
      )
      .subscribe()
  }
  function schedulingDetectVersionToReload(minute = 5) {
    schedulingDetectVersionToReloadIntervalId.value = setInterval(() => {
      detectVersionToReload()
    }, minute * 60 * 1000)
  }

  return {
    checkCookieIsEnabled,
    detectVersionToReload,
    schedulingDetectVersionToReload
  }
}
